<template>
  <div id="vehicles-list-item-editor">
    <div @click="open_editor(car)">
      <slot name="button">
      Add/Edit
      </slot>
    </div>
    <v-dialog v-model="car_edit_dialog" max-width="420">
        <v-card style="border-radius: 8px; display: flex; flex-wrap: wrap; justify-content: center" elevation="0">
            <v-card-title style="padding-bottom: 0">
                <span>{{form_dialog_title}}</span>
            </v-card-title>
               <v-form class="edit_card_container" style="padding-top: 0; width: 100%" v-model="vehicles_lists_form_valid" ref="vehicles_lists_validation_form">
                 <v-card-text style="padding: 0 15px 30px">
                    <v-radio-group :readonly="watch_only" class="margin-t" style="padding-top: 0;" v-model="dialog_type.list_name">
                      <div style="display: flex; justify-content: space-around">
                        <v-radio
                            :label="$i18n.t('pages.vehicles_lists.whitelist')"
                            value="whitelist"
                            color="#207EA9"
                            style="margin-bottom: 0"
                        />
                        <v-radio
                            :label="$i18n.t('pages.vehicles_lists.blacklist')"
                            value="blacklist"
                            style="margin-bottom: 0"
                            color="#207EA9"
                        />
                      </div>
                    </v-radio-group>
                    <v-subheader class="subheader">{{ $i18n.t('pages.vehicles_lists.dialog.license_plate') }}</v-subheader>
                    <v-text-field
                        :readonly="watch_only"
                        outlined
                        class="rounded_8px height_56px"
                        :placeholder="$i18n.t('pages.vehicles_lists.dialog.license_plate')"
                        v-model="edited_car.license_plate"
                        :rules="validation_rules.license_plate"
                        @keydown.space.prevent
                    />
                    <v-subheader class="subheader margin-t">{{ $i18n.t('pages.vehicles_lists.dialog.owner_name') }}</v-subheader>
                    <v-text-field
                        :readonly="watch_only"
                        outlined
                        class="rounded_8px height_56px"
                        :placeholder="$i18n.t('pages.vehicles_lists.dialog.owner_name')"
                        v-model="edited_car.owner_fio"
                        :rules="validation_rules.owner_fio"
                    />

                    <div v-if="dialog_type.list_name === 'whitelist'">
                      <v-subheader class="subheader margin-t">{{ $i18n.t('pages.vehicles_lists.dialog.pass_type') }}</v-subheader>
                      <v-radio-group :readonly="watch_only" v-model="selected_pass_type" style="margin-top: 5px">
                        <div style="display: flex; justify-content: space-around">
                          <v-radio
                              :label="$i18n.t('pages.vehicles_lists.pass_types.temporary')"
                              value="temporary"
                              style="margin-bottom: 0"
                              color="#207EA9"
                          />
                          <v-radio
                              :label="$i18n.t('pages.vehicles_lists.pass_types.single')"
                              value="single"
                              style="margin-bottom: 0"
                              color="#207EA9"
                          />
                        </div>
                      </v-radio-group>
                      <div v-if="addressees.length > 0">
                        <div style="display: flex; justify-content: start" class="vuetify_sucks">
                          <v-checkbox
                              hide-details
                              :ripple="false"
                              class="my_ass"
                              v-model="all_addressees_selected"
                              @change="set_all_addressees_selection_status"
                          />
                          <v-subheader class="subheader">
                                <span>{{ $i18n.t('pages.vehicles_lists.dialog.accessible_locations') }}</span>
                          </v-subheader>
                        </div>
                        <div>
                          <v-select
                            :readonly="watch_only"
                            multiple
                            chips
                            small-chips
                            outlined
                            class="rounded_8px"
                            :placeholder="$i18n.t('pages.vehicles_lists.dialog.accessible_locations') "
                            :items="addressees"
                            item-text="name"
                            item-value="external_id"
                            v-model="edited_car.addressees_external_ids"
                          >
                            <template v-slot:selection="{item, index}">
                              <v-chip v-if="index < 4">
                                <span>{{ item.name }}</span>
                              </v-chip>
                              <span v-if="index === 4" class="grey--text caption">
                                (+{{ edited_car.addressees_external_ids.length - 3 }})
                              </span>
                            </template>
                          </v-select>
                        </div>
                      </div>
                      <div v-if="addressees.length < 1 && systemParams.network_role === 'master'">
                        <div style="display: flex; justify-content: start" class="vuetify_sucks">
                          <v-checkbox
                              hide-details
                              :ripple="false"
                              class="my_ass"
                              v-model="all_lpr_devices_selected"
                              @change="set_all_lpr_devices_selection_status"
                          />
                          <v-subheader class="subheader">
                                <span>PH: Устройства распознавания</span>
                          </v-subheader>
                        </div>
                        <div>
                          <v-select
                            :readonly="watch_only"
                            multiple
                            chips
                            small-chips
                            outlined
                            class="rounded_8px"
                            placeholder="PH: Устройства распознавания"
                            :items="lpr_devices"
                            item-text="name"
                            item-value="inner_id"
                            v-model="edited_car.lpr_devices_inner_ids"
                          >
                            <template v-slot:selection="{item, index}">
                              <v-chip v-if="index < 4">
                                <span>{{ item.name }}</span>
                              </v-chip>
                              <span v-if="index === 4" class="grey--text caption">
                                (+{{ edited_car.lpr_devices_inner_ids.length - 3 }})
                              </span>
                            </template>
                          </v-select>
                        </div>
                      </div>
                      <v-subheader class="subheader">{{ $i18n.t('pages.vehicles_lists.dialog.access_start_date') }}</v-subheader>
                      <div style="display: flex; flex-direction: row; justify-content: space-between">
                        <date-picker
                            :disabled="watch_only"
                            style="width: 48%"
                            :formatted_date="formatted_start_date"
                            :placeholder="$i18n.t('pages.vehicles_lists.dialog.date')"
                            @input_date="(params) => {this.access_datetime.start_date = params.date}"
                        />
                        <time-picker
                            :disabled="watch_only"
                            style="width: 48%"
                            :time="access_datetime.start_time"
                            :placeholder="$i18n.t('pages.vehicles_lists.dialog.time')"
                            :width="'220px'"
                            @save_time="(params) => {this.access_datetime.start_time = params.time}"
                            @input="suggest_expiration_time"
                        />
                      </div>
                      <v-subheader class="subheader margin-t">{{ $i18n.t('pages.vehicles_lists.dialog.access_expiration_date') }}</v-subheader>
                      <div style="display: flex; flex-direction: row; justify-content: space-between">
                        <date-picker
                            :disabled="watch_only"
                            style="width: 48%"
                            :formatted_date="formatted_expiration_date"
                            :placeholder="$i18n.t('pages.vehicles_lists.dialog.date')"
                            @input_date="(params) => {this.access_datetime.expiration_date = params.date}"
                        />
                        <time-picker
                            :disabled="watch_only"
                            style="width: 48%"
                            :time="access_datetime.expiration_time"
                            :placeholder="$i18n.t('pages.vehicles_lists.dialog.time')"
                            :width="'220px'"
                            @save_time="(params) => {this.access_datetime.expiration_time = params.time}"
                        />
                      </div>

                      <v-subheader class="subheader margin-t">{{ $i18n.t('pages.vehicles_lists.dialog.days_of_week_and_times_of_day') }}</v-subheader>
                      <div>
                        <v-menu v-if="car_edit_dialog" offset-y top content-class="elevation-4" :close-on-content-click="false">
                          <template v-slot:activator="{on, attrs}">
                            <v-text-field
                                readonly
                                class="rounded_8px height_56px"
                                outlined
                                placeholder="Gimme days, times"
                                v-bind="attrs"
                                v-on="on"
                                v-model="form_weekdays_field_text"
                            />
                          </template>
                          <div>
                            <v-card max-width="360px" min-height="280px" style="display: flex; align-items: center">
                              <v-card-text>
                                <v-virtual-scroll :items="days_of_week" height="150px" item-height="30">
                                  <template v-slot="{ item }">
                                    <v-list-item>
                                      <v-list-item-title>
                                        <v-checkbox
                                            multiple
                                            :readonly="watch_only"
                                            style="margin: 5px 10px 5px 0;"
                                            color="#207EA9"
                                            :label="$i18n.t(`days_of_week.${item}`)"
                                            :value="item"
                                            v-model="daily_access.selected_days_of_week"
                                        />
                                      </v-list-item-title>
                                    </v-list-item>
                                  </template>
                                </v-virtual-scroll>
                                <div style="display: flex; justify-content: space-between; margin-top: 15px">
                                  <time-picker
                                    :disabled="watch_only"
                                    style="width: 48%; height: 56px"
                                    :time="minutes_to_time_str(daily_access.daily_start_time_in_mins)"
                                    :placeholder="$i18n.t('pages.vehicles_lists.dialog.time')"
                                    :width="'220px'"
                                    @save_time="(params) => {daily_access.daily_start_time_in_mins = this.get_time_in_minutes(params.time)}"
                                  />
                                  <time-picker
                                      :disabled="watch_only"
                                      style="width: 48%; height: 56px"
                                      :time="minutes_to_time_str(daily_access.daily_finish_time_in_mins)"
                                      :placeholder="$i18n.t('pages.vehicles_lists.dialog.time')"
                                      :width="'220px'"
                                      @save_time="(params) => {daily_access.daily_finish_time_in_mins = this.get_time_in_minutes(params.time)}"
                                  />
                                </div>
                              </v-card-text>
                            </v-card>
                          </div>
                        </v-menu>
                      </div>
                    </div>

                    <div v-if="!watch_only"
                         style="padding-top: 30px; display: flex; justify-content: space-between; width: 100%"
                    >
                      <v-btn
                          class="white--text width-170"
                          height="42"
                          color="#DBEAF1"
                          elevation="0"
                          @click="car_edit_dialog = false"
                      >
                        <span style="color: #207EA9" class="button-font">{{ $i18n.t('general.close') }}</span>
                      </v-btn>
                      <v-btn
                          class="white--text width-170"
                          height="42"
                          color="#207ea9"
                          elevation="0"
                          @click="save_car"
                      >
                        <span class="button-font">{{ $i18n.t('general.save') }}</span>
                      </v-btn>
                    </div>
                   <div v-else style="padding-top: 30px; display: flex; justify-content: center; width: 100%">
                     <v-btn
                          class="white--text"
                          style="width: 100%"
                          height="42"
                          color="#DBEAF1"
                          elevation="0"
                          @click="car_edit_dialog = false"
                      >
                        <span style="color: #207EA9" class="button-font">{{ $i18n.t('general.close') }}</span>
                      </v-btn>
                   </div>
                 </v-card-text>
               </v-form>
        </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import moment from 'moment'
import 'moment-timezone'
import {i18n} from "@/i18n";
import TimePicker from "@/custom_components/TimePicker";
import DatePicker from "@/custom_components/DatePicker";
import {common_funcs} from "@/mixins/common";
import {date_time_converters} from "@/mixins/date_time_converters";

export default {
  name: "VehiclesListItemEditor",
  components: {DatePicker, TimePicker},
  props: ['car', 'car_index', 'requests_to_server', 'addressees', 'lpr_devices', 'list_name', 'watch_only'],
  mixins: [common_funcs, date_time_converters],
  data: function () {
      return {
        vehicles_lists_form_valid: true,
        validation_rules: {
          license_plate: [
            v => !!v || i18n.t('validation.this_field_is_required'),
          ],
          date_field: [
              v => !!v || i18n.t('validation.this_field_is_required'),
          ],
          start_date: [
              v => !!v || i18n.t('validation.this_field_is_required'),
          ],
          start_time: [
              v => !!v || i18n.t('validation.this_field_is_required'),
          ]
        },
        car_edit_dialog: false,
        dialog_type: {
          list_name: this.list_name,
          action: 'add'
          },
        menus: {
          start_date_menu: '',
          start_time_menu: '',
          expiration_date_menu: '',
          expiration_time_menu: '',
        },
        access_datetime: {
          start_date: null,
          expiration_date: null,
          start_time: null,
          expiration_time: null,
        },
        selected_pass_type: this.car.pass_type ? this.car.pass_type : 'temporary',
        access_type_before_editing: this.car.access_type,
        days_of_week: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'],
        daily_access: {
          selected_days_of_week: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'],
          daily_start_time_in_mins: 0,
          daily_finish_time_in_mins: 0,
        },
        edited_car: Object.assign({}, this.car),
        default_car: {
          // _id: '',
          inner_id: '',
          license_plate: '',
          owner_fio: '',
          access_type: '', // blacklist or whitelist
          access_by_datetime_granted: '',
          pass_type: 'temporary', // single or temporary

          access_days: [],
          daily_access_start_time: 0, //int, minutes from 00:00
          daily_access_finish_time: 0, //int, minutes from 00:00

          access_start_datetime: '',
          access_expiration_datetime: '',

          addressees_external_ids: [],
          lpr_devices_inner_ids: [],
          is_suspended: false,
          source: 'manual',
          status: 'active',
          entity_status: 'arrives',
          external_id: '',
        },
      }
    },
    methods: {
      open_editor: function(car) {
        if (car.license_plate) {
          this.dialog_type.list_name = this.car.access_type
          this.dialog_type.action = 'edit' // Only whitelist cars can be edited
          this.edited_car = Object.assign({}, this.car)
          this.access_datetime.start_date = this.json_to_date_picker_str(this.car.access_start_datetime)
          this.access_datetime.start_time = this.json_to_time_str(this.car.access_start_datetime)
          this.access_datetime.expiration_date = this.json_to_date_picker_str(this.car.access_expiration_datetime)
          this.access_datetime.expiration_time = this.json_to_time_str(this.car.access_expiration_datetime)

          this.daily_access.daily_start_time_in_mins = this.car.daily_access_start_time
          this.daily_access.daily_finish_time_in_mins = this.car.daily_access_finish_time
          this.daily_access.selected_days_of_week = this.car.access_days
        } else {
          this.edited_car.addressees_external_ids = this.all_addressees_external_ids_array()
        }

        this.car_edit_dialog = true
      },
      close_editor: function () {
        this.car_edit_dialog = false
        this.access_datetime.start_date = ''
        this.access_datetime.start_time = ''
        this.access_datetime.expiration_date = null
        this.access_datetime.expiration_time = null
        this.daily_access.daily_start_time_in_mins = 0
        this.daily_access.daily_finish_time_in_mins = 0
        this.daily_access.selected_days_of_week = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']
        this.edited_car = Object.assign({}, this.default_car)
        this.$refs.vehicles_lists_validation_form.resetValidation()
      },
      save_car: function () {
        if (this.watch_only) return
        if (!this.$refs.vehicles_lists_validation_form.validate()) return
        if (this.start_date_later_than_exp_date) {
          this.setSnackbar({
            text: i18n.t('validation.incorrect_start_date_and_expiration_date')
          })
          return
        }
        this.edited_car.access_type = this.dialog_type.list_name
        this.edited_car.pass_type = this.selected_pass_type
        let t = this
        this.edited_car.access_start_datetime = this.picker_date_time_to_json(this.access_datetime.start_date,
                                                               this.access_datetime.start_time)
        this.edited_car.access_expiration_datetime = this.picker_date_time_to_json(this.access_datetime.expiration_date,
                                                               this.access_datetime.expiration_time)
        this.edited_car.access_days = this.daily_access.selected_days_of_week
        this.edited_car.daily_access_start_time = this.daily_access.daily_start_time_in_mins
        this.edited_car.daily_access_finish_time = this.daily_access.daily_finish_time_in_mins
        this.edited_car.access_by_datetime_granted = this.is_access_by_datetime_granted(this.access_datetime.start_date, this.access_datetime.start_time)

        let _edited_car = this.edited_car

        if (this.requests_to_server === false) {
          t.$emit('edit_vehicles_lists', {
            // old_list: _edited_car.access_type,
            old_list: this.access_type_before_editing,
            car: _edited_car,
            car_index: t.edited_car_index,
            // access_type_was_changed: _edited_car.access_type !== this.access_type_before_editing
          })
        }
        else {
          let data = {'car': this.edited_car}
          if (this.dialog_type.action === 'add') {
            this.$http({url: this.$http_hostname + '/vehicles_lists/add', data: data, method: 'POST'})
            .then( (resp) => {
              _edited_car.inner_id = resp.data['new_car_inner_id']
              if (_edited_car.access_type === 'whitelist' ||_edited_car.access_type === 'blacklist') {
                t.$emit('edit_vehicles_lists', {
                  old_list: _edited_car.access_type,
                  car: _edited_car,
                  car_index: t.edited_car_index
                })
              }
              t.setSnackbar({
                text: i18n.t('notifications.vehicles_lists.plate_added', {plate: _edited_car.license_plate})
              })
            })
            .catch( (error) => {
              t.show_error_message(error)
            })
          }
          else if (this.dialog_type.action === 'edit') {
            this.$http({url: this.$http_hostname + '/vehicles_lists/edit', data: data, method: 'POST'})
            .then(() => {
              t.$emit('edit_vehicles_lists', {list: _edited_car.access_type,
                old_list: this.access_type_before_editing,
                car: _edited_car,
                car_index: t.edited_car_index,
              })
              t.setSnackbar({
                text: i18n.t('notifications.vehicles_lists.plate_edited', {plate:_edited_car.license_plate})
              })
            })
            .catch(error => {
              t.show_error_message(error)
            })
          }
        }
        this.car_edit_dialog = false
      },
      suggest_expiration_time: function () {
        if (this.access_datetime.expiration_time == undefined) {
          this.access_datetime.expiration_time = this.access_datetime.start_time
        }
      },
      is_access_by_datetime_granted(date, time) {
        if (['known', 'blacklist'].includes(this.edited_car.access_type) || (!date || !time)) {
          return false
        }
        let sys_dt = moment(this.$store.state.system_datetime).tz(this.$store.state.current_system_timezone).utc()
        let access_start_dt = moment(this.picker_date_time_to_date_obj(date, time)).tz( this.$store.state.current_system_timezone, true).utc()
        let granted_by_datetime = sys_dt >= access_start_dt
        if (!granted_by_datetime) return false
        let today_index = sys_dt.day() - 1
        today_index = today_index < 0 ? 6 : today_index
        let granted_by_access_days = this.edited_car.access_days.includes(this.days_of_week[today_index])
        if (!granted_by_access_days) return false
        let curr_time_in_system_timezone = moment(sys_dt).tz(this.$store.state.current_system_timezone).format('HH:mm')
        let curr_time_in_minutes = this.time_str_to_minutes(curr_time_in_system_timezone)
        const [start_minutes, finish_minutes] = [this.edited_car.daily_access_start_time, this.edited_car.daily_access_finish_time]
        if (finish_minutes < start_minutes) {
          return curr_time_in_minutes <= finish_minutes || curr_time_in_minutes >= start_minutes
        }
        else if (finish_minutes > start_minutes) {
          return start_minutes <= curr_time_in_minutes && curr_time_in_minutes <= finish_minutes
        }
        return true
      },
      all_addressees_external_ids_array: function () {
        let addressees_external_ids_array = []
          this.addressees.forEach(item => {
            addressees_external_ids_array.push(item['external_id'])
          })
        return addressees_external_ids_array
      },
      all_lpr_devices_inner_ids_array: function () {
        let lpr_devices_inner_ids_array = []
          this.lpr_devices.forEach(item => {
            lpr_devices_inner_ids_array.push(item['inner_id'])
          })
        return lpr_devices_inner_ids_array
      },
      set_all_addressees_selection_status: function () {
        if (!this.all_addressees_selected) {
          this.edited_car.addressees_external_ids = this.all_addressees_external_ids_array()
        } else {
          this.edited_car.addressees_external_ids = []
        }
      },
      set_all_lpr_devices_selection_status: function () {
        if (!this.all_lpr_devices_selected) {
          this.edited_car.lpr_devices_inner_ids = this.all_lpr_devices_inner_ids_array()
        } else {
          this.edited_car.lpr_devices_inner_ids = []
        }
      },
      ...mapActions(['setSnackbar'])
    },

  computed: {
    edited_car_index: function () {
      return this.car_index === 'undefined' ? -1 : this.car_index
    },
    form_dialog_title: function () {
      if (this.watch_only) return i18n.t('pages.vehicles_lists.dialog.view_pass')
      if (this.dialog_type.list_name === 'whitelist') {
        if (this.dialog_type.action === 'add') return i18n.t('pages.vehicles_lists.dialog.add_to_whitelist')
        if (this.dialog_type.action === 'edit') return i18n.t('pages.vehicles_lists.dialog.edit_pass')
      }
      else if (this.dialog_type.list_name === 'blacklist') {
        if (this.dialog_type.action === 'add') return i18n.t('pages.vehicles_lists.dialog.add_to_blacklist')
        if (this.dialog_type.action === 'edit') return i18n.t('pages.vehicles_lists.dialog.edit_pass')
      }
      else if (this.dialog_type.list_name === 'known_cars') {
        return i18n.t('pages.vehicles_lists.dialog.edit_pass')
      }
      return ''
    },
    formatted_start_date: function () {
      return this.picker_date_to_slash_str(this.access_datetime.start_date)
    },
    formatted_expiration_date: function () {
      return this.picker_date_to_slash_str(this.access_datetime.expiration_date)
    },
    form_weekdays_field_text: function () {
      let selected_weekdays = []
      for (let weekday of this.daily_access.selected_days_of_week) {
        let index_of_weekday = this.days_of_week.indexOf(weekday)
        selected_weekdays.splice(index_of_weekday, 0, i18n.t(`days_of_week_short.${weekday}`))
      }
      selected_weekdays = selected_weekdays.join(', ')
      if (selected_weekdays) selected_weekdays = selected_weekdays + '; '
      let daily_access_start_time = this.minutes_to_time_str(this.daily_access.daily_start_time_in_mins)
      let daily_access_finish_time = this.minutes_to_time_str(this.daily_access.daily_finish_time_in_mins)
      let text_from_time_to_time = i18n.t('pages.vehicles_lists.dialog.from_time_to_time',
                                    {time_from: daily_access_start_time, time_to: daily_access_finish_time})
      return `${selected_weekdays} ${text_from_time_to_time}`
    },
    start_date_later_than_exp_date: function () {
      let start_date_str = this.access_datetime.start_date
      let exp_date_str = this.access_datetime.expiration_date
      if (!start_date_str || !exp_date_str) return false
      let parsed_start_date = moment(start_date_str, 'YYYY-MM-DD')
      let parset_exp_date = moment(exp_date_str, 'YYYY-MM-DD')
      return parsed_start_date > parset_exp_date
    },
    all_addressees_selected: {
      get() {
        return this.edited_car.addressees_external_ids.length === this.addressees.length
      },
      set() {}
    },
    all_lpr_devices_selected: {
      get() {
        return this.edited_car.lpr_devices_inner_ids.length === this.lpr_devices.length
      },
      set() {}
    },
    license_plate () {
      return this.edited_car.license_plate
    },
    ...mapGetters(['systemParams'])
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    selected_pass_type: function (val) {
      this.$refs.vehicles_lists_validation_form.resetValidation()
    },
    car_edit_dialog: function (val) {
      !val && this.close_editor()
    },
    list_name: function (val) {
      this.dialog_type.list_name = val
    },
    license_plate: function (val) {
      this.edited_car.license_plate = this.normilize_license_plate(val)
    }
  },
}
</script>

<style scoped>
/*.v-menu__content {*/
/*    border: 1px solid #A7AFB2;*/
/*    border-radius: 0;*/
/*}*/
</style>